import { drupalSiteUrl } from "../../config";

export default {
	Any: "Cualquiera",
	BOOKMARK: "MARCADOR",
	BOOKMARKED: "MARCADA",
	CANCEL: "CANCELAR",
	Category: "Category",
	Catalog: "Catálogo",
	CERTIFICATE: "CERTIFICADO",
	CERTIFICATES: "CERTIFICADOS",
	Certificate_Number: "Número de certificado",
	certificateInstructions: "Para obtener crédito, muestra este certificado en tu cita de WIC",
	certificateIphoneHelp: "To save your certificate:",
	clickHere: "haz clic aquí.",
	COMPLETE_CLASS: "COMPLETAR LA CLASE",
	Completion_Date: "Fecha en que se completó",
	CONTINUE: "CONTINUAR",
	completeAnonymously: "Para completar tu lección sin ingresar al sistema, ",
	completeAnonymously2: "Completar tu lección sin ingresar al sistema",
	CurrentEmailAddress: "Correo electrónico actual",
	dontHaveAnAccount: "¿No tienes una cuenta?",
	DOWNLOAD_PDF: "DESCARGAR PDF",
	EmailAddress: "Correo Electrónico",
	Filter: "Filtrar",
	footerText: `
		Llame al 800-942-3678 para obtener más información sobre Texas WIC.<br/>
		<a href=${`${drupalSiteUrl}/es/quienes-somos/comunicate-con-nosotros`} target="_blank">Comunícate con nosotros</a> | <a href="https://hhs.texas.gov/es/informacion-para-ver-archivos" target="_blank">Información de visualización de archivos</a> | <a href=${`${drupalSiteUrl}/es/node/58`} target="_blank">Socios de salud</a> | <a href="https://hhs.texas.gov/es/normas-del-sitio" target="_blank">Política de Internet</a><br/>
		Última actualización del sitio Monday, April 9, 2018  Esta institución es un proveedor de igualdad de oportunidades. © 2009-2018 TexasWIC.org / La Comisión de Salud y Servicios Humanos (HHSC). Todos los derechos reservados.
		`,
	IN_PROGRESS: "EN-PROGRESO",
	keepingYourFamilyHealthy: "Cómo mantener a tu familia sana",
	languageToggle: "IN ENGLISH",
	loginMessage:
		"No tienes que ingresar al sistema, pero hacerlo te permite dejar una clase a la mitad y regresar luego, llevar un registro de las clases completadas y marcar las clases que quieres tomar en otro momento.",
	LOG_IN: "INGRESAR",
	Log_In: "Ingresar",
	LOG_OUT: "SALIR",
	LOGIN: "INGRESAR",
	logoutPrompt: "¿Está segura de que desea salir del sistema?",
	PRINT: "IMPRIMIR",
	PROFILE: "PERFIL",
	reenterEmail: "Ingresa el correo electrónico otra vez",
	REMOVE_BOOKMARK: "ELIMINAR MARCADOR",
	satisfactionSurvey: "Encuesta de Satisfacción",
	SAVE: "GUARDAR",
	SAVE_PICTURE: "GUARDAR FOTO",
	SIGN_UP: "INSCRÍBETE",
	signUp: "Inscríbete",
	skipToContent: "Saltar al contenido principal",
	START: "INICIAR",
	START_asterisk: "START *",
	SUBMIT: "ENVIAR",
	surveyInstructions:
		"Por favor contesta las preguntas opcionales a continuación para decirnos sobre tu experiencia con esta lección o haz clic en el botón “Completar lección” abajo para obtener tu certificado.",
	thanksForSigningUp: "GRACIAS POR INSCRIBIRTE",
	thankYouMessage:
		"Vestibulum laoreet lacus vitae blandit finibus. Aliquam erat volutpat. In turpis elit, ultricies vel massa ac, consectetur eleifend dolor.",
	thhs: "TEXAS HEALTH AND HUMAN SERVICES",
	UpdateEmailAddress: "Actualizar correo electrónico",
	updatedEmail: "Se actualizó bien el correo electrónico",
	viewAccessibilityVersion: "Para ir a la versión accesible de la clase, ",
	viewAccessibilityVersion2: "Ir a la versión accesible de la clase",
	whatYoullLearn: "LO QUE APRENDERÁS",

	errors: {
		accountNotFound:
			"Esta cuenta no fue encontrada. Revisa el correo electrónico que ingresaste o regístrate para abrir una cuenta.",
		emailRequired: "Se requiere una dirección de correo electrónico",
		existingAccount: "Ya existe una cuenta con ese correo electrónico",
		loginFailed: "No se pudo ingresar",
		matchEmails: "Las direcciones de correo electrónico no son iguales",
		registerFailed: "No se pudo registrar la cuenta",

		failedToBookmark: "No funcionó el marcador",
		failedToVerifyClass:
			"No se pudo verificar la identificación de la clase. Por favor usa el enlace que te dieron.",
		failedToLoadClass: "No se pudieron cargar los detalles de la clase",
		failedToLoadClasses: "No se pudieron cargar los cursos",
		failedToUpdateEmail: "No se pudo actualizar el correo electrónico",
		failedToRegister: "You have already registered for this session",
	},
	faq: {
		questions: {
			question1: "¿Qué necesito hacer para tomar mi clase de WIC?",
			question2: "¿Y si no tengo impresora?",
			question3:
				"¿Cuántas clases necesito terminar para recibir crédito por asistir a mi clase de WIC?",
			question4: "¿Necesito tomar una clase en especial?",
			question5: "¿Pueden enviarme por correo electrónico una copia de mi certificado?",
			question6:
				"Cuando inicio una sesión para tomar una clase, ¿para qué usa TexasWIC.org mi dirección de correo electrónico?",
			question7: "¿Qué hago si las clases en línea no están funcionando bien?",
			question8: "¿Cómo actualizo mi dirección de correo electrónico?",
			question9:
				"El sitio web se ve diferente. ¿Dónde puedo encontrar los certificados de las clases que ya terminé?",
		},
		answers: {
			answer1:
				"<a href='/login?language=es'>Inicia una sesión</a> usando tu dirección de correo electrónico. Luego verás <span style='font-weight: bold'>Mis clases</span> y el <span style='font-weight: bold'>Catálogo de clases</span>. Haz clic en la clase que te gustaría tomar.Cuando termines la clase, recibirás un certificado. Puedes guardar, descargar o imprimir el certificado para presentarlo en la cita de WIC. También puedes acceder a Mis clases para mostrar tu certificado en tu cita de WIC",
			answer2:
				"Puedes guardar o descargar el certificado a tu teléfono para mostrarlo en la cita de WIC. También puedes acceder a <span style='font-weight: bold'>Mis clases</span> por medio de tu teléfono y mostrar tu certificado en tu cita de WIC.",
			answer3:
				"Para recibir crédito, solo necesitas terminar una clase antes de la cita de WIC.",
			answer4: "No. Puedes tomar cualquier clase que te interese.",
			answer5:
				"No. Nuestro sistema actual no envía certificados por correo electrónico. Cuando ingreses al sistema usando tu dirección de correo electrónico, podrás ver qué clases has terminado. Puedes mostrar estos certificados en tu cita de WIC.",
			answer6:
				"TexasWIC.org solo usa tu dirección de correo electrónico para llevar un control de tu progreso en las clases y guardar copias de tus certificados. TexasWIC.org no te enviará por correo electrónico ninguna correspondencia que no hayas solicitado. Solo recibirás correos electrónicos si te suscribiste para recibir nuestros boletines informativos.",
			answer7:
				"Envía un correo electrónico a<a href='mailto:WICGeneral@hhsc.state.tx.us'>WICGeneral@hhsc.state.tx.us</a>para informarnos de que el sitio web no está funcionando. Si no puedes terminar una clase, de todos modos podrás recibir tus beneficios de WIC cuando vayas a la cita. Sin embargo, quizás te pidan que tomes una clase a tu propio ritmo o que participes en una clase en grupo en la oficina de WIC.",
			answer8:
				'Después de acceder al sistema, haz clic en "Profile" o perfil. Se abrirá una ventana que mostrará tu dirección de correo electrónico actual. Ingresa tu nueva dirección y haz clic en guardar. La próxima vez que accedas al sistema, usa tu nueva dirección de correo electrónico. Cuando accedas al sistema con tu nuevo correo electrónico, podrás seguir viendo tu progreso en las clases, tus clases favoritas y tus certificados.',
			answer9:
				"Si empezaste una clase o terminaste una clase antes del 10 de mayo de 2018, el historial y el progreso de la clase no aparecerán en el nuevo sitio de TexasWIC.org. Para recibir crédito por la clase, informa en la oficina de WIC que tu certificado se perdió debido al cambio.",
		},
	},
	survey: {
		questions: {
			question1: "¿Qué tan probable es que pruebes algo de lo que aprendiste en esta clase?",
			question2:
				"¿Qué tan probable es que le recomiendes esta clase a una amiga o familiar que esté en WIC?",
			question3: "¿Qué otros temas te interesaría ver en una clase?",
			question4: "¿Tienes algún otro comentario sobre esta clase?",
		},
		answers: {
			extremelyLikely: "Muy probable",
			somewhatLikely: "Algo probable",
			neitherLikelyOrUnlikely: "Ni probable ni poco probable",
			somewhatUnlikely: "Poco probable",
			extremelyUnlikely: "Muy poco probable",
		},
	},
	tabNames: {
		MY_CLASSES: "MIS CLASES",
		CATALOG: "CATÁLOGO",
		FAQ: "PREGUNTAS FRECUENTES",
	},
	type: {
		interactive: "Clic y aprende",
		video: "Video de Actividad",
		recorded: "Pre-grabadas",
		live: "En vivo en línea",
	},
	typeDescription: {
		interactive:
			"Clases interactivas en línea que puedes completar a tu propio ritmo. Disponibles en cualquier momento, de día o de noche.",
		video:
			"Una actividad en video que puedes realizar a cualquier hora, de día o de noche.",
		recorded: "Videos de clases que puedes ver en cualquier momento, de día o de noche.",
		live:
			"Clases transmitidas en vivo a tu computadora o teléfono. Disponibles en días y horas programadas.",
	},
	Dates_Time_Offered: "Fechas y horas ofrecidas",
	ENROLL: "INSCRÍBETE",
	Class_Topics: "Temas de las clases",
	Format: "Formato",
	classDisclaimer:
		"*Al hacer clic en este enlace saldrá del sitio web de HHS de Texas y estará sujeto a la política de privacidad y seguridad del nuevo sitio.",
	completeClassLoginMessage:
		"No tienes que ingresar al sistema, pero hacerlo te permite dejar una clase a la mitad y regresar luego, llevar un registro de las clases completadas y marcar las clases que quieres tomar en otro momento.",
	classFull: "CLASE LLENA**",
	registrationDisclaimer1: "**Ya no hay lugares disponibles en esta clase. Consulta nuestras ",
	registrationDisclaimer2: "clases en línea,",
	registrationDisclaimer3:
		" que puedes tomar en cualquier momento, o regresa en unos días para ver las fechas y los horarios de nuevas clases en vivo.",
	liveClassCalendar: "Calendario de Clases en Vivo",
	calendarDescription:
		"Las clases en vivo duran de 30 a 60 minutos y se ofrecen en días y horarios fijos. Ve nuestro calendario de dos semanas para saber sobre las próximas clases en vivo. Escoge un tema que te interese y selecciona “Aprende más” para inscribirte.",
	returnToCatalog: "Volver al Catálogo",
	learnMore: "Aprende Más",
	youMayAlsoLike: "También te puede interesar",
	hostedBy: "Sitio Hospedado Por",
	FirstName: "Primer Nombre",
	LastName: "Apellido",
	DontRegisterNow: "No hacer la inscripción en este momento.",
	liveClassDescription:
		"Las clases se realizan en Livestorm, una plataforma de seminarios web de terceros.",
	liveClassDescription1:
		"Para más información, lee nuestra página de  <a href='/faq?language=es'>preguntas frecuentes.</a>",
	livestormTerms:
		"Acepto las <a href='https://livestorm.imgix.net/1127/1639478139-cgu-s-es.pdf'>Condiciones de servicio de Livestorm</a> y el uso de datos personales tal y como se explica en la <a href='https://livestorm.imgix.net/1127/1637919597-pp-es.pdf'>Política de privacidad y seguridad de Livestorm</a>, que puede variar de la política de privacidad y seguridad de Texas HHS que se aplica al resto de este sitio.*",
	Save: "Guardar",
	Cancel: "Cancelar",
	myWic: "myWic",
	linkToMyWicInstructions:
		"Vincula tu perfil de TexasWIC.org a tu cuenta de myWIC para acceder fácilmente y a cualquier hora a la información sobre las clases en línea que has tomado.",
	linkYourMyWicAccount: "Vincula tu cuenta de myWIC",
	linkToMyWic: "Vincular cuenta de myWIC",
	whatsThis: "Más sobre myWIC",
	currentlyLinkedToMyWic: "Tu perfil de TexasWIC.org se ha vinculado a myWIC.",
	ChangeEmailAddress: "Cambiar correo electrónico",
	ChangeEmailAddressInstructions:
		"¿Cambiaste de correo electrónico? Después de actualizar tu correo electrónico, recuerda vincular el nuevo a myWIC. ¿Tienes alguna pregunta? Visita nuestra ",
	ClassesFAQ: "página de preguntas frecuentes sobre las clases.",
	EnterNewEmail: "Escribe tu correo electrónico nuevo:",
	ReenterNewEmail: "Vuelve a escribir tu correo electrónico nuevo:",
};



// WEBPACK FOOTER //
// ./src/constants/strings/spanish.js